// src/private/src/pages/app/clients/components/SummaryChips.jsx
import React, { memo } from 'react';
import { Box, Stack, Typography } from '@mui/material';
import { getMetricTier } from './MetricCell';

const CHIP_METRICS = [
  { key: 'setRate', label: 'Set Rate', format: 'percent' },
  { key: 'issueRate', label: 'Issue Rate', format: 'percent' },
  { key: 'demoRate', label: 'Demo Rate', format: 'percent' },
  { key: 'netCloseRate', label: 'Close Rate', format: 'percent' },
  { key: 'costOfMarketing', label: 'COM', format: 'percent' },
];

const TIER_COLORS = {
  good: { bg: 'rgba(34, 197, 94, 0.12)', border: 'rgba(34, 197, 94, 0.35)', text: '#16a34a' },
  warn: { bg: 'rgba(245, 158, 11, 0.12)', border: 'rgba(245, 158, 11, 0.35)', text: '#d97706' },
  bad: { bg: 'rgba(239, 68, 68, 0.12)', border: 'rgba(239, 68, 68, 0.35)', text: '#dc2626' },
  neutral: { bg: 'transparent', border: 'rgba(0,0,0,0.12)', text: 'text.secondary' },
};

const formatPct = (val) => {
  const num = Number(val);
  if (!Number.isFinite(num)) return '--';
  return `${(num * 100).toFixed(1)}%`;
};

/**
 * Horizontal row of colored chips showing key funnel conversion rates.
 * Each chip is colored based on the conditional thresholds.
 */
function SummaryChips({ metrics = {} }) {
  return (
    <Stack
      direction="row"
      spacing={1}
      flexWrap="wrap"
      useFlexGap
      sx={{ mt: 2, mb: 1 }}
    >
      {CHIP_METRICS.map((m) => {
        const value = metrics[m.key];
        const tier = getMetricTier(m.key, value);
        const colors = TIER_COLORS[tier] || TIER_COLORS.neutral;

        return (
          <Box
            key={m.key}
            sx={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: 0.75,
              px: 1.5,
              py: 0.5,
              borderRadius: 2,
              border: '1px solid',
              borderColor: colors.border,
              bgcolor: colors.bg,
            }}
          >
            <Typography
              variant="caption"
              sx={{ fontSize: '0.7rem', color: 'text.secondary', fontWeight: 500 }}
            >
              {m.label}
            </Typography>
            <Typography
              variant="caption"
              sx={{ fontSize: '0.8rem', fontWeight: 700, color: colors.text }}
            >
              {formatPct(value)}
            </Typography>
          </Box>
        );
      })}
    </Stack>
  );
}

export default memo(SummaryChips);
